import { render, staticRenderFns } from "./RequestingDoctor.vue?vue&type=template&id=3a27cfda"
import script from "./RequestingDoctor.vue?vue&type=script&lang=js"
export * from "./RequestingDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports